<script setup lang="ts">
	import { ref, onMounted } from 'vue';
	
	const props = defineProps({
		vendors: Array
	});
	
	const refMap = ref(null);
	
	const emit = defineEmits(['showFilter']);

	async function prepareMap(map): void {
		console.log("preparing");
		var latlngbounds = new window.google.maps.LatLngBounds();
		for (let vendor of props.vendors) {
			let location = await geocodeAddress(getAddress(vendor));
			const marker = new window.google.maps.marker.AdvancedMarkerElement({
				map: map,
				position: location,
				title: vendor.place
			});
			latlngbounds.extend(marker.position);
		}
		console.log("geocoding done");
		map.setCenter(latlngbounds.getCenter());
		if (props.vendors.length>1) {
			map.fitBounds(latlngbounds);
		}				
	}
		
	function geocodeAddress(address) {
		return new Promise((resolve, reject) => {
			const geocoder = new window.google.maps.Geocoder();
			geocoder.geocode({address: address}, (results, status) => {
				if (status === 'OK') {
					resolve(results[0].geometry.location);
				} else {
					reject(status);
				}    
			});    
		});
	}
		
	function getAddress(vendor): string {
		return vendor.street+","+vendor.city+","+vendor.zip;
	}
	
	function showFilter(): void {
		emit('showFilter');
	}

	onMounted(() => {
		const midMap = { lat: 50.073658, lng: 14.418540 };
		const map = new window.google.maps.Map(refMap.value, {
			zoom: 12,
			minZoom: 9,
			center: midMap,
			disableDefaultUI: true,
			zoomControl: true,
			mapId: 'googleMap'
		});
		prepareMap(map);
	});
</script>
<template>
	<div ref="refMap" id="googleMap" class="googleMap"></div>
	<div style="padding-top: 10px;">
		<button @click="showFilter">Zpět</button>
	</div>
</template>
<style>
.googleMap {
    height: 510px;
}
</style>